import { Link, useParams } from "react-router-dom";
import SponsoredRoles from "./SponsoredRoles";
import JobAlert from "./JobAlert";
import SimilarCompanies from "./SimilarCompanies";
import CompanyHero from "./CompanyHero";
import OccupationCrossLink from "./OccupationCrossLink";
import * as paths from "../../../constants/paths";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyDetails } from "../../../states/actions/fetchCompanies";
import { useEffect, useState } from "react";
import { getSponsorTypeBadge } from "../../../helpers/helpers";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { ToastContainer } from "react-toastify";
import { use } from "react";
// {paths.SITE_BASE_URL + "/images/no-image.svg"}

const CompanyDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchCompanies.content);
  const isLoading = useSelector((state) => state.fetchCompanies.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading,
  );
  const [visibleJobs, setVisibleJobs] = useState(5);
  // console.log('data',data);

  const {
    jobs_page_content,
    company,
    jobs,
    totalJobs,
    meta_desc,
    site_settings,
    cos,
  } = data;

  const [page, setPage] = useState(1);
  const limit = 5;

  useEffect(() => {
    dispatch(fetchCompanyDetails(id, page, limit));
  }, [id, page]);
  // useEffect(() => {
  //   dispatch(fetchCompanyDetails(id));
  // }, []);
  const companyData = {
    id: company?.id,
    name: company?.title,
    image: company?.image,
    // profileUrl: "/company/techcorp",
    sponsorType: getSponsorTypeBadge(company?.sponsor_type),
    verified: Number(company?.is_verified) === 1 ? true : false,
    // verified: true,
    description: company?.short_desc,
    location: company?.company_location,
    employees: company?.no_of_employees,
    founded: company?.founded_year,
    website: company?.company_website,
    totalJobs: totalJobs,
  };

  const initialPage = page - 1;
  const pageCount = Math.ceil(totalJobs / limit);
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleLoadMore = () => {
    setVisibleJobs((prev) => prev + 5);
  };

  useDocumentTitle(data.page_title);

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="company_details">
            <CompanyHero
              company={company}
              cos={cos}
              totalJobs={totalJobs}
            />
            <div className="contain">
              <div className="main_row">
                <div className="left_column">
                  <SponsoredRoles
                    companyName={company?.title}
                  />

                  {/* Vacancies live on the job board, always. This page is
                      the sponsorship record: one design for every company,
                      carrying whatever we hold. Where there is no CoS record
                      yet the section above simply does not render - the same
                      progressive rule the directory card follows - rather
                      than the page switching to a different layout. */}
                  <div className="live_jobs_link">
                    <div className="h4 m-0">
                      <img
                        src={paths.SITE_BASE_URL + "/images/icon_briefcase.png"}
                        alt=""
                      />
                      {totalJobs > 0
                        ? `${totalJobs} live ${
                            totalJobs === 1 ? "vacancy" : "vacancies"
                          } right now`
                        : "No live vacancies right now"}
                    </div>
                    <p>
                      {totalJobs > 0
                        ? "Open roles we are currently advertising for this employer."
                        : "Their careers page is worth watching, and an alert will tell you when something lands."}
                    </p>
                    {totalJobs > 0 ? (
                      <Link
                        to={`/open-jobs/1?searchKeyword=${encodeURIComponent(
                          company?.title || "",
                        )}`}
                        className="site_btn"
                      >
                        View on the job board
                      </Link>
                    ) : (
                      <Link to="/job-alerts" className="site_btn blank">
                        Set a job alert
                      </Link>
                    )}
                  </div>
                </div>
                <div className="right_column">
                  <OccupationCrossLink
                    company={company?.title}
                    topRole={cos?.top_role}
                  />
                  {/* <SimilarCompanies /> */}
                  <JobAlert />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default CompanyDetails;
